import { Col, Spin, Tooltip } from 'antd';
import clsx from 'classnames';
import React, { useCallback } from 'react';
import ReactPlayer from 'react-player';
import { useSelector } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import NoData from '../../../assets/icons/nodata.png';
import PauseIcon from '../../../components/Player/icons/pause.svg';

const CameraItem = ({
  camera,
  isSelected,
  onDoubleClick,
  onClick,
  getAppearanceTimeStyle,
  playerRefs,
  handleProgress,
  isSeeking,
  layout,
}) => {
  const {
    generateLinkStorageFileByTime,
    loadingGenerateLinkStorageFileByTime,
  } = useSelector((state) => state);
  const isLoading = loadingGenerateLinkStorageFileByTime?.includes(
    camera.serial
  );

  const renderPlayer = useCallback(() => {
    if (isSeeking && generateLinkStorageFileByTime?.[camera.serial]) {
      return isSelected ? (
        <div
          style={{
            height: 120,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img
            alt="thumbnail"
            src={PauseIcon}
            style={{
              width: 60,
              height: 60,
            }}
          />
        </div>
      ) : (
        <ReactPlayer
          ref={(ref) => (playerRefs.current[camera.serial] = ref)}
          url={generateLinkStorageFileByTime?.[camera.serial]?.secureLink}
          onReady={() => {}}
          onProgress={({ playedSeconds }) =>
            handleProgress(camera.serial, playedSeconds)
          }
          width="100%"
          height={120}
          controls={false}
          playing={true}
        />
      );
    } else if (!isSeeking) {
      return (
        <img
          alt="camera-thumbnail"
          src={camera.thumbnail}
          width={'100%'}
          style={layout === 'grid' ? { height: 200 } : { height: 120 }}
        />
      );
    } else {
      return (
        <img
          alt="NoData"
          src={NoData}
          style={{ width: '100%', height: 120, objectFit: 'cover' }}
        />
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSeeking, generateLinkStorageFileByTime, isSelected]);

  return (
    <Col
      className={clsx('cam-item', { selected: isSelected })}
      xl={layout === 'grid' ? 8 : 24}
      md={24}
      xs={24}
      key={camera.serial}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
    >
      <Tooltip title={camera.name} placement="topLeft">
        <div
          className="name-camera"
          style={{
            fontSize: 13,
            textOverflow: 'ellipsis',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 1,
            display: '-webkit-box',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          {camera.name}
        </div>
      </Tooltip>
      {isLoading ? (
        <Spin
          indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />}
          style={{
            width: '100%',
            margin: '30px 0px',
          }}
        />
      ) : (
        renderPlayer()
      )}
      <div
        style={{
          display: 'flex',
          position: 'relative',
          height: '6px',
          width: '100%',
          backgroundColor: '#f5f5f5',
        }}
      >
        {getAppearanceTimeStyle(camera.records).map((block, index) => (
          <div
            key={index}
            style={{
              zIndex: block.zIndex ?? 1,
              backgroundColor: block.isSeekTime ? block.color : block.color,
              width: block.isSeekTime ? block.width : block.width,
              height: '100%',
              position: block.isSeekTime ? 'absolute' : 'relative',
              left: block.isSeekTime ? block.position : '0%',
            }}
          />
        ))}
      </div>
    </Col>
  );
};

export default CameraItem;
